import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';

import cuentaService from '../../../service/administracion/cuentaService';
import tipoCuentaService from '../../../service/administracion/tipoCuentaService';
import bancoService from '../../../service/administracion/bancoService';
import trabajadorService from '../../../service/administracion/trabajadorService';
import monedaService from '../../../service/administracion/monedaService';
import planCuentaService from '../../../service/administracion/planCuentaService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            tiposCuenta: [],
            bancos: [],
            trabajadores: [],
            monedas: [],
            cuentasContables: [],
            entidades: [],
            estados: estadoMock.values,
            filter: {
                idTipoCuenta: 0,
                cuentaBancario: '',
                idMoneda: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    handleClearFilters = () => {
        var filter = {
            idTipoCuenta: 0,
            cuentaBancario: '',
            idMoneda: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cuentaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cuenta.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cuentaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Banco.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await cuentaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await cuentaService.eliminar(values);
            else
                response = await cuentaService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoCuenta: 0,
            cuentaBancario: '',
            cuentaInterbancario: '',
            idEntidad: 0,
            idMoneda: 0,
            idPlanCuenta: 0,
            flagContabilidad: false,
            flagView: false,
            fechaStr: global.fetchCurrentDateStr(),
            saldoInicialDebe: 0,
            saldoInicialHaber: 0,
            flagBanco: false,
            tiposCuenta: [],
            bancos: [],
            trabajadores: [],
            monedas: [],
            cuentasContables: [],
            entidades: [],
        };
    };

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tiposCuenta = this.state.tiposCuenta;
        formValues.bancos = this.state.bancos;
        formValues.trabajadores = this.state.trabajadores;
        formValues.monedas = this.state.monedas;
        formValues.cuentasContables = this.state.cuentasContables;
        formValues.entidades = this.state.entidades;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await cuentaService.obtenerPorIdEdit(values.id);
        var entidades = this.fetchSourceEntidades(true);

        if (response !== undefined) {
            response.tiposCuenta = this.state.tiposCuenta;
            response.bancos = this.state.bancos;
            response.trabajadores = this.state.trabajadores;
            response.monedas = this.state.monedas;
            response.cuentasContables = this.state.cuentasContables;
            response.entidades = this.fetchSourceEntidades(response.flagBanco);

            this.setState({ visible: true, formValues: response });
        }
        this.setState({
            visible: true,
            formValues: {
                ...this.state.formValues,
                id: values.id,
                idTipoCuenta: values.idCuenta,
                cuentaBancario: values.numeroCuenta,
                cuentaInterbancario: values.cuentaInterbancaria,
                idEntidad: values.idBanco,
                idMoneda: values.idMoneda,
                idPlanCuenta: values.idPlanCuenta,
                flagContabilidad: values.flagContabilidad,
                flagView: response.length == 0 ? false : response[0].flagView,
                fechaStr: values.fechaAperturaStr,
                saldoInicialDebe: values.saldoInicialDebe,
                saldoInicialHaber: values.saldoInicialHaber,
                flagBanco: values.flagBanco,
                entidades: entidades

            },
        })
    };


    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await cuentaService.registrar(values);
            else
                response = await cuentaService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleChangeFormTipoCuenta = (flagBanco) => {
        var entidades = this.fetchSourceEntidades(flagBanco);
        this.setState({ formValues: { ...this.state.formValues, entidades } });
    }

    fetchSourceEntidades = (flagBanco) => {
        var entidades = [];

        if (flagBanco) {
            this.state.bancos.forEach(item => {
                entidades.push({
                    id: item.idEntidad,
                    name: item.razonSocial
                });
            });
        }
        else {
            this.state.trabajadores.forEach(item => {
                entidades.push({
                    id: item.idEntidad,
                    name: item.nombre + ' ' + item.apellidoMaterno + ' ' + item.apellidoPaterno
                });
            });
        }

        return entidades;
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, cuentaService.paginacion);

        const tiposCuenta = await tipoCuentaService.listar();
        const bancos = await bancoService.listar();
        const trabajadores = await trabajadorService.listar();
        const monedas = await monedaService.listar();
        const cuentasContables = await planCuentaService.listarPorMayorGrado();

        this.setState({
            loadingSource: false,
            tiposCuenta: tiposCuenta ? tiposCuenta : [],
            bancos: bancos ? bancos : [],
            trabajadores: trabajadores ? trabajadores : [],
            monedas: monedas ? monedas : [],
            cuentasContables: cuentasContables ? cuentasContables : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Cuenta"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    tiposCuenta={this.state.tiposCuenta}
                    monedas={this.state.monedas}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChangeTipoCuenta={this.handleChangeFormTipoCuenta}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
} 